// extracted by mini-css-extract-plugin
module.exports = {"billImage":"BillGraphic_billImage__NK_G2","rotate":"BillGraphic_rotate__P1_MC","toTheSide":"BillGraphic_toTheSide__qMoQh","waiting":"BillGraphic_waiting__xqZEH"};